export default __webpack_public_path__ + "static/media/PRZYMIERZE.e9ad6240.png";